import { css } from "@emotion/css";
import { Trans } from "react-i18next";

import { Text } from "../../foundations/typography/Text";

import { useContract } from "./hooks";

type Props = {
  accessID: string;
  contractIDs: string[];
};

export function ContractView({ accessID, contractIDs }: Props) {
  const { getContractHTML, isError } = useContract({
    accessID,
    contractIDs,
    style: "full",
  });

  return (
    <div
      className={styles.content}
      dangerouslySetInnerHTML={
        isError ? undefined : { __html: getContractHTML() }
      }
      aria-label="contract-content"
      role="textbox"
      tabIndex={0}
    >
      {isError && (
        <Text color="text-weak" testID="contract-fetch-error">
          <Trans>Something went wrong</Trans>
        </Text>
      )}
    </div>
  );
}

const styles = {
  content: css({
    // text/border color for Clickwrap document
    "& *": {
      color: `var(--text-weak) !important`,
      borderColor: `var(--border-base) !important`,
      borderRadius: "var(--border-radius-2) !important",
    },
  }),
};
